import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.utiliti.ng";

// Request OTP for admin login
export const requestLoginOTP = async (email, password) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/admin/request-login-otp`, {
            email,
            password
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: 'Network error' };
    }
};

// Verify OTP and complete login
export const verifyLoginOTP = async (email, otp) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/admin/verify-login-otp`, {
            email,
            otp
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: 'Network error' };
    }
};

// Request OTP for sensitive operation
export const requestOperationOTP = async (operationType, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/admin/request-operation-otp`,
            { operationType },
            {
                headers: {
                    'x-auth-token': `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: 'Network error' };
    }
};

// Verify OTP for sensitive operation
export const verifyOperationOTP = async (otp, operationType, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/admin/verify-operation-otp`, {
            otp,
            operationType
        },
            {
                headers: {
                    'x-auth-token': `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: 'Network error' };
    }
};

export default {
    requestLoginOTP,
    verifyLoginOTP,
    requestOperationOTP,
    verifyOperationOTP
};
